<template>
  <div class="app-container">
    <el-row :gutter="20">
      <!--用户数据-->
      <el-col :span="4">
        <el-tree :data="treeData" :default-expand-all="true" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
      </el-col>
      <el-col :span="20">
        <el-row :gutter="10" class="mb8">
          <el-col :span="1.5">
            <el-button
              type="primary"
              icon="el-icon-plus"
              size="mini"
              @click="handleAdd"
              class="yl-button"
            >新增</el-button>
          </el-col>
        </el-row>
        <el-table 
          height="83vh"
          v-loading="loading" 
          row-key="user_id"
          border 
          stripe 
          :data="userList" 
          :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
          <el-table-column label="用户名称" align="center" prop="user_realname" width="160" :show-overflow-tooltip="true" />
          <el-table-column label="邮箱" align="center" prop="username" :show-overflow-tooltip="true" />
          <el-table-column label="部门" align="center" prop="dept" width="180" :show-overflow-tooltip="true" />
          <el-table-column label="序列号" align="center" width="100" prop="serialNumbers">
            <template slot-scope="scope">
              <el-button v-show="scope.row.check != 0" type="text" @click="showSerialNumber(scope.row)">查看</el-button>
            </template>
          </el-table-column>
          <el-table-column label="手机号码" align="center" prop="phone"/>
          <!-- <el-table-column label="创建时间" align="center" prop="create_time" width="250"></el-table-column> -->
          <el-table-column label="状态" align="center" width="100">
            <template slot-scope="scope">
              <p v-if="scope.row.create_by_id != '0' && scope.row.create_by_id != null">
                {{scope.row.is_del == 1?'启用':'禁用'}}
              </p>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            class-name="small-padding fixed-width"
          >
            <template slot-scope="scope">
              <el-button
                class="item"
                size="mini"
                type="text"
                icon="el-icon-bj"
                @click="handleUpdate(scope.row)"
                v-if="scope.row.create_by_id != '0' && scope.row.create_by_id != null"
              ></el-button>
              <el-button
                class="item"
                v-if="scope.row.create_by_id != '0' && scope.row.create_by_id != null"
                size="mini"
                type="text"
                icon="el-icon-sc"
                @click="handleDelete(scope.row)"
              ></el-button>
              <span v-else>--</span>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>

    <!-- 添加或修改参数配置对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="40%" append-to-body @close='closeDialog'>
      <el-form ref="form" :model="form" :rules="rules" label-width=".8rem">
        <el-row>
          <el-col :span="12">
            <el-form-item label="用户名" prop="user_realname">
              <el-input v-model="form.user_realname" placeholder="请输入用户名" class="yl-input_noIcon"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="归属部门" prop="dept">
              <el-cascader
                v-model="aaa"
                :options="selectData"
                :show-all-levels="false"
                :props="props"
                @change="handleChange"></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="手机号码" prop="phone">
              <el-input v-model="form.phone" placeholder="请输入手机号码" class="yl-input_noIcon" maxlength="11" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="邮箱" prop="username">
              <el-input v-model="form.username" placeholder="请输入邮箱" class="yl-input_noIcon" maxlength="50" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="用户密码" prop="password">
              <el-input v-model="form.password" placeholder="请输入用户密码" class="yl-input_noIcon" :type="passwordType">
                <i slot="suffix" :class="icon_password" @click="showPassword"></i>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="确认密码" prop="confirmPassword">
              <el-input v-model="form.confirmPassword" placeholder="请确认用户密码" class="yl-input_noIcon" :type="confirmPasswordType">
                <i slot="suffix" :class="icon_confirmPassword" @click="showConfirmPassword"></i>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="岗位">
              <el-select v-model="form.post" placeholder="请选择">
                <el-option
                  v-for="(item,index) in postList"
                  :key="index"
                  :label="item.post_name"
                  :value="item.post_name"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态">
              <el-radio-group v-model="form.is_del">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="2">禁用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="序列号">
              <!-- <el-select v-model="form.serialNumbers" multiple class="select" placeholder="请选择">
                <el-option
                  v-for="(item,index) in serialNumberList"
                  :key="index"
                  :label="item.serial_number"
                  :value="item.serial_number"
                ></el-option>
              </el-select> -->
              <el-button
                type="primary"
                size="mini"
                @click="seletTbaleData"
                class="yl-button"
              >点击选择</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" class="yl-button" @click="submitForm">确 定</el-button>
        <el-button @click="cancel" class="yl-button2">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 序列号展示 -->
    <el-dialog title="序列号" :visible.sync="openSerialNumber" width="70%" append-to-body>
      <div class="list_index">
        <el-table stripe border height="64vh" :data="serialNumberList">
          <el-table-column label="项目现场" prop="getewayName"></el-table-column>
          <el-table-column label="mqtt网关序列号" align="center" prop="serialNumber"></el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <!-- 选择序列号表格 -->
    <el-dialog title="选择序列号" :visible.sync="selectSerialNumber" width="70%" append-to-body @close="close">
      <div class="list_index">
        <div class="operation">
          <div class="left">
            <el-radio-group v-model="status" size="small">
              <el-radio-button label="0">{{$t('GatewayName')}}</el-radio-button><!--网关名称-->
              <el-radio-button label="1">{{$t('serialNumber')}}</el-radio-button><!--序列号-->
            </el-radio-group>
            <el-input v-model="switchValue" size="small" :placeholder="status == '0' ? $t('PleaseinputGatewayName') : '请输入序列号'" class="input">
              <i slot="prefix" class="el-input__icon el-icon-ss" @click="swich()"></i>
            </el-input>
            <el-button type="primary" class="yl-button" @click="swich()">搜索</el-button>
          </div>
          <div class="right">
            <el-button type="primary" class="ml0 yl-button" @click="StorageSelectSerialNumber">确定</el-button>
          </div>
        </div>
        <el-table stripe border ref="multipleTable" height="64vh" :data="serialNumberData" @selection-change="handleSelectionChange">
          <el-table-column  type="selection"></el-table-column>
          <el-table-column label="项目现场" prop="geteway_name"></el-table-column>
          <el-table-column label="mqtt网关序列号" align="center" prop="serial_number"></el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import DataService from '@/api/data'
export default {
  name: "User",
  data() {
    const valiConfirmPassword = (rule, value, callback) => {
      if(this.form.confirmPassword == undefined){
        callback(new Error("请确认密码"));
      }else if(this.form.confirmPassword != this.form.password){
        callback(new Error("两次密码填写不同"));
      }else{
        callback();
      }
    };
    return {
      serialNumbers:[],//选中的序列号列表
      switchValue:'',
      status:'0',
      serialNumberData:[],
      selectSerialNumber:false,
      aaa:[],
      dept_id:'',
      //级联选择器数据
      selectData:[],
      //树形结构数据
      treeData:[],
      props:{
        emitPath:false,
      },
      dept:[],
      confirmPasswordType:'password',
      passwordType:'password',
      icon_confirmPassword:'el-input__icon el-icon-eyes',
      icon_password:'el-input__icon el-icon-eyes',
      //序列号列表
      serialNumberList:[],
      //序列号弹窗
      openSerialNumber:false,
      //公司名称
      company_name:undefined,
      // 遮罩层
      loading: false,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 用户表格数据
      userList: null,
      // 弹出层标题
      title: "",
      // 岗位选项
      postList: undefined,
      //部门选项
      deptList:undefined,
      //序列号选项
      serialNumberList:undefined,
      // 是否显示弹出层
      open: false,
      // 日期范围
      dateRange: [],
      // 表单参数
      form: {
        user_id:this.$store.state.user_id,
        dept: undefined,
        deptId: undefined,
        user_realname: undefined,
        password: undefined,
        phone: undefined,
        username: undefined,
        confirmPassword: undefined,
        is_del:1,
        serialNumbers: [],
        post: undefined,
      },
      defaultProps: {
        children: "children",
        label: "label"
      },
      // 表单校验
      rules: {
        confirmPassword:[{ required: true,validator:valiConfirmPassword, trigger: 'blur' }],
        user_realname: [
          { required: true, message: "用户名称不能为空", trigger: "blur" }
        ],
        password: [
          { required: true, message: "用户密码不能为空", trigger: "blur" }
        ],
        username: [
          {
            required: true,
            type: "email",
            message: "'请输入正确的邮箱地址",
            trigger: ["blur", "change"]
          }
        ],
        phone: [
          {
            required: true,
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: "请输入正确的手机号码",
            trigger: "blur"
          }
        ]
      }
    };
  },
  created() {
    this.getList();
    this.getDeptList();
    this.getPostList();
    this.getSerialNumberList();
  },
  methods: {
    seletTbaleData(){
      let _this = this;
      this.selectSerialNumber = true;
      this.serialNumberList.forEach(el=>{
        this.serialNumberData.forEach(ele=>{
          if(el.serialNumber == ele.serial_number){
            setTimeout(()=>{
              _this.$refs.multipleTable.toggleRowSelection(ele)
            },100)
          }
        })
      })
    },
    //关闭选择序列号弹窗
    close(){
      setTimeout(() => {
        this.$refs.multipleTable.clearSelection();
      }, 100);
    },
    //点击确定将选中的序列号赋值在表单里
    StorageSelectSerialNumber(){
      this.form.serialNumbers = this.serialNumbers;
      this.selectSerialNumber = false;
    },
    //选择序列号改变
    handleSelectionChange(val){
      if(val){
        this.serialNumbers = []
        val.forEach(el=>{
          this.serialNumbers.push({
            getewayName:el.geteway_name,
            serialNumber:el.serial_number
          })
        })
      }
    },
    //根据项目现场名称和序列号查询
    swich(){
      DataService.getProjectsiteData({
        page:1,
        size:10000,
        status:this.status,
        online_status:2,
        user_id:this.$store.state.user_id,
        getewayNameOrSerialNumber:this.switchValue
      }).then(res=>{
        this.serialNumberData = res.data.projectSiteList;
      }).catch(err=>{
        this.$message.error(err.msaage)
      })
    },
    //查看密码
    showConfirmPassword(){
      if( this.confirmPasswordType=="text"){
          this.confirmPasswordType="password";
          //更换图标
          this.icon_confirmPassword="el-input__icon el-icon-eyes";
      }else {
          this.confirmPasswordType="text";
          this.icon_confirmPassword="el-input__icon el-icon-eyes_sel";
      };
    },
    showPassword(){
      if( this.passwordType=="text"){
          this.passwordType="password";
          //更换图标
          this.icon_password="el-input__icon el-icon-eyes";
      }else {
          this.passwordType="text";
          this.icon_password="el-input__icon el-icon-eyes_sel";
      };
    },
    //关闭弹窗的回调
    closeDialog(){
      this.reset()
    },
    /** 查询序列号列表 **/ 
    getSerialNumberList(){
      DataService.projectsiteData({
        user_id:this.$store.state.user_id,
        status:2,
        page:1,
        size:1000
      }).then(res=>{
        this.serialNumberData = res.data.projectSiteList;
      }).catch(err=>{
        this.$message.error(err.msaage)
      })
    },
     /** 查询部门列表 */
     getDeptList() {
      DataService.getDeptInfo({
        user_id:this.$store.state.user_id
      }).then(res=>{
        this.deptList = res.data;
        this.treeData = this.handleData(res.data,0) 
        this.selectData = this.handleData(res.data,1) 
      }).catch(err=>{
        this.$message.error(err.message)
      })
    },
    //使用递归处理数据
    handleData(data,type){
      return(
        data&&data.map(item =>{
          if(type == 0){
            if(item.children.length > 0){
              return{
                label:item.deptName,
                dept_id:item.deptId,
                children:this.handleData(item.children,0)
              }
            }else{
              return{
                label:item.deptName,
                dept_id:item.deptId,
              }
            }
          }else{
            if(item.children.length > 0){
              return{
                label:item.deptName,
                value:[item.deptName,item.deptId],
                children:this.handleData(item.children,1)
              }
            }else{
              return{
                label:item.deptName,
                value:[item.deptName,item.deptId],
              }
            }
          }
        })
      )
    },
    //选中树状节点
    handleNodeClick(e){
      this.dept_id = e.dept_id
      this.getList()
    },
    /** 查询岗位列表 */
    getPostList() {
      DataService.getPostInfo({
        user_id:this.$store.state.user_id
      }).then(res=>{
        this.postList = res.data; 
      }).catch(err=>{
        this.$message.error(err.message)
      })
    },
    /** 查询用户列表 */
    getList() {
      // this.loading = true;
      DataService.getUserJurisdictionInfo({
        user_id:this.$store.state.user_id,
        dept_id:this.dept_id
      }).then(res=>{
        this.userList = res.data;
        if(res.data.length > 0){
          this.company_name = res.data[0].company_name;
        }
        this.addStation(this.userList)
      }).catch(err=>{
        this.$message.error(err.message)
      })
    },
    //查看序列号
    showSerialNumber(row){
      this.serialNumberList = row.serialNumbers;
      this.openSerialNumber = true;
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        user_id:this.$store.state.user_id,
        dept: undefined,
        deptId: undefined,
        user_realname: undefined,
        password: undefined,
        phone: undefined,
        username: undefined,
        is_del:1,
        confirmPassword: undefined,
        serialNumbers: [],
        post: undefined,
      };
      this.resetForm("form");
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.dateRange = [];
      this.resetForm("queryForm");
      this.handleQuery();
    },
    /** 新增按钮操作 */
    handleAdd() {
      // this.reset();
      this.open = true;
      this.title = "添加用户";
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.serialNumberList = row.serialNumbers;
      this.getSerialNumberList();
      this.form = {
        user_id:row.user_id,
        password:this.$Base64.decode(row.password),
        confirmPassword:this.$Base64.decode(row.password),
        dept: [row.dept,row.dept_id],
        user_realname: row.user_realname,
        phone: row.phone,
        username: row.username,
        serialNumbers: row.serialNumbers,
        post: row.post,
        is_del:row.is_del,
        create_by_id:this.$store.state.user_id
      }
      this.title = "修改用户";
      this.open = true;
    },
    /** 提交按钮 */
    submitForm: function() {
      if(this.form.serialNumbers && this.title != "修改用户"){
        let formSerialNumbers = []
        this.form.serialNumbers.forEach(el=>{
          formSerialNumbers.push(el.serialNumber)
        })
        this.form.serialNumbers = formSerialNumbers;
      }
      this.form.password = this.$Base64.encode(this.form.password);
      this.form.confirmPassword = this.$Base64.encode(this.form.confirmPassword)
      if(this.title != "修改用户"){
        this.form.deptId = this.form.dept[1];
      }
      this.form.dept = this.form.dept[0];
      this.$refs["form"].validate(valid => {
        if (valid) {
          if(this.title == '添加用户'){
            DataService.addUser({
                ...this.form,
                company_name:this.company_name
              }).then(res=>{
              this.$message.success('新增成功')
              this.open = false;
              this.getList();
            }).catch(err=>{
              this.$message.error(err.message)
              this.form.password = this.$Base64.decode(this.form.password);
              this.form.confirmPassword = this.$Base64.decode(this.form.confirmPassword)
            })
          }else{
            DataService.updataUser({
                ...this.form,
              }).then(res=>{
              this.$message.success('修改成功')
              this.open = false;
              this.getList();
            }).catch(err=>{
              this.$message.error(err.message)
              this.form.password = this.$Base64.decode(this.form.password);
              this.form.confirmPassword = this.$Base64.decode(this.form.confirmPassword)
            })
          }
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      let _this = this;
      this.$confirm('是否确认删除用户名称为"' + row.user_realname + '"的数据项?', "警告", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(function() {
         DataService.deleteUser({
            user_id:row.user_id
          }).then(res=>{
             _this.$message.success("删除成功");
             _this.getList()
          }).catch(err=>{
            _this.$message.error(err.message)
          })
        })
    },
    // 给属性为空的值赋横杠
    addStation(data) {
      // console.log(data);
      if (!typeof data === "object") {
        return;
      }
      Object.keys(data).forEach((k) => {
        if (data[k] === "" || data[k] === null) {
          data[k] = "--";
        }
        if (data[k] instanceof Object) {
          this.addStation(data[k]);
        }
      });
      return data;
    },
    //层联选择器数据变化
    handleChange(val){
      this.form.dept = val;
    }
  }
};
</script>
<style lang="scss" scoped>
.item{
  margin-left: 15px;
  margin-right: 15px;
}
.select{
  width:480px
}
.input{
  width:258px;
  position: absolute;
}
.operation{
  display: flex;
  justify-content: space-between;
  .left{
    width: 1000px;
    /deep/ .el-radio-button:last-child .el-radio-button__inner{
      border-radius: 0;
    }
    /deep/ .el-input__inner{
      border-radius: 0 4px 4px 0;
      height: 44px;
      border: 1px solid rgba(128, 197, 255, 0.4);;
      border-left:none ;
      background: linear-gradient(0deg, rgba(98, 115, 165, 0.2), rgba(0, 174, 255, 0));
      color: #fff;
      font-size: 18px;
      padding-left: 58px;
    }
    .yl-button{
      margin-left: 270px;
    }
  }
}
</style>